import { useQuery } from "@tanstack/react-query";
import { FOUNDING_ACCOUNT_QUERY_KEY } from "./constants";
import { fetchFoundingAccount } from "./founding-api";

/**
 * Account-level Founding Partner status (ADR-0010 §9).
 *
 * `enabled` gates the fetch so a viewer who would 403 on the founding-account
 * endpoint (e.g. SUPPORT) — or a target user who isn't a host / venue owner —
 * never triggers a request. The badge reads must stay cheap and role-gated.
 */
export function useFoundingAccount(userId: string, enabled: boolean) {
  return useQuery({
    queryKey: [...FOUNDING_ACCOUNT_QUERY_KEY, userId] as const,
    queryFn: () => fetchFoundingAccount(userId),
    enabled: enabled && userId.length > 0,
    staleTime: 30_000,
  });
}
